module.exports = __webpack_public_path__ + "img/SAVE.0f9cca4c.svg";